import { FormSection } from "../../../../components/propertyDescription/descriptionUi";
import RadioOption from "./RadioOption";
import {
  ACCESS_AND_AREA,
  PROPERTY_CONTAINS,
  SINGULARITIES,
} from "./constants";

type BenefitItem = {
  label: string;
  radioGroupName: string;
  attributeName: string;
};

type Props = {
  values: Record<string, boolean>;
  onChange: (attributeName: string, value: boolean) => void;
};

function BenefitGrid({
  items,
  values,
  onChange,
}: {
  items: BenefitItem[];
  values: Record<string, boolean>;
  onChange: (attributeName: string, value: boolean) => void;
}) {
  return (
    <div className="grid grid-cols-1 gap-x-6 gap-y-2 sm:grid-cols-2 xl:grid-cols-3">
      {items.map((item) => (
        <RadioOption
          key={item.attributeName}
          label={item.label}
          radioGroupName={item.radioGroupName}
          checked={!!values[item.attributeName]}
          onChange={(value) => onChange(item.attributeName, value)}
        />
      ))}
    </div>
  );
}

export default function BenefitsSection({ values, onChange }: Props) {
  return (
    <>
      <FormSection title="Acesso e área">
        <BenefitGrid items={ACCESS_AND_AREA} values={values} onChange={onChange} />
      </FormSection>
      <FormSection title="Tem no imóvel">
        <BenefitGrid
          items={PROPERTY_CONTAINS}
          values={values}
          onChange={onChange}
        />
      </FormSection>
      <FormSection title="Diferenciais">
        <BenefitGrid items={SINGULARITIES} values={values} onChange={onChange} />
      </FormSection>
    </>
  );
}
